import { useState } from "react";
import "./ApplyingTo.css";

const ApplyingTo = ({ selectedCategory, setSelectedCategory, handleNextPage }) => {
  const handleChange = (event) => {
    setSelectedCategory("private_university");
    console.log(selectedCategory);
  };

  return (
    <div className="app_apply">
      <h2 className="font-semibold text-left sm:font-medium text-xl sm:text-3xl">
        Where are you applying to?
      </h2>
      <div className="uniType flex flex-col gap-2">
        <label htmlFor="">Category</label>
        <select name="" id="" value={selectedCategory} onChange={handleChange}>
          <option value="private_university">Private University</option>
        </select>
      </div>
      <button className="wide-btn btn mt-8" onClick={() => handleNextPage()}>
        Next
      </button>
    </div>
  );
};

export default ApplyingTo;
